import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid2,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Icons } from "../../../config/MuiIcons.config";
import AppInputField from "../../../components/CommonReusableComponent/AppInputField/AppInputField";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import MUIErrorText from "../../../components/MUIErrorText/MUIErrorText";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  createArea,
  updateArea,
  getAllDepartmentListByBranchId,
} from "../../../helpers/api-functions-helper";
import { useSnackbar } from "../../../contexts/Snackbar.context";
import { useBackdrop } from "../../../contexts/BackDrop.context";
import {
  APP_MESSAGE,
  SNACKBAR_VARIANT,
  FORM_VALIDATIONS,
  USE_FORMIK_SCHEMA,
  ERROR_MESSAGE,
  // ERROR_MESSAGE,
} from "../../../config/Messages.config";
import {
  checkDuplicateEntity,
  replaceTextToCaplitalize,
  setRequiredDataForDropdown,
} from "../../../common/CommonFunctions";
import { useMediaQuery } from "@mui/material";
import AppAutoCompleteField from "../../../components/CommonReusableComponent/AppAutoCompleteField/AppAutoCompleteField";
import { getUserRoleAndScreens } from "../../../services/authServices/auth.services";

const CreateNewOrUpdateAreaModal = ({
  Open,
  ToggleDialogBox,
  Title,
  DialogData,
  SetDialogData,
  FetchAreaByBranchAndDept,
  ListOfAllBranches,
  CurrentBranchId,
  CurrentDepartmentId,
  AllAreaNames,
}) => {
  const { showSnackbar } = useSnackbar();
  const { accountId } = getUserRoleAndScreens();
  // eslint-disable-next-line no-unused-vars
  let isMobileDevice = useMediaQuery("(max-width:500px)");
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const authUser = JSON.parse(
    localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER)
  );
  const isUpdateMode = DialogData && DialogData?.id;
  const [isCreateOrUpdateClicked, setIsCreateOrUpdateClicked] = useState(false);
  const [usersByPlant, setUsersByPlant] = useState([]);
  const [departments, setDepartments] = useState([]);

  // Function used to create new role
  const createNewArea = (DATA) => {
    setIsCreateOrUpdateClicked(true);
    createArea(DATA)
      .then((res) => {
        if (res && res.data) {
          const { statusCode, success, message, data } = res.data;
          if (!success && statusCode !== 200) {
            showSnackbar(
              data || message || APP_MESSAGE.AREA_MASTER.CREATE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.AREA_MASTER.CREATE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            handleResetDialogBox();
            if (CurrentBranchId && CurrentDepartmentId) {
              FetchAreaByBranchAndDept();
            }
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.AREA_MASTER.CREATE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setIsCreateOrUpdateClicked(false);
      });
  };

  // Function used to update existing role
  const updateExistingArea = (DATA) => {
    setIsCreateOrUpdateClicked(true);
    updateArea(DATA)
      .then((res) => {
        if (res && res.data) {
          const { statusCode, success, data, message } = res.data;
          if (!success && statusCode !== 200) {
            showSnackbar(
              data || message || APP_MESSAGE.AREA_MASTER.UPDATE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.AREA_MASTER.UPDATE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            handleResetDialogBox();
            if (CurrentBranchId && CurrentDepartmentId) {
              FetchAreaByBranchAndDept();
            }
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.AREA_MASTER.UPDATE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setIsCreateOrUpdateClicked(false);
      });
  };

  // Fetch all departments under branch
  const fetchAllDepartmentsOfBranch = (branchId) => {
    const payload = {
      branchIds: [branchId],
      accountId: accountId,
    };
    showBackdrop();
    getAllDepartmentListByBranchId(payload)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data } = response.data;
          if (statusCode && statusCode === 200) {
            setRequiredDataForDropdown(setDepartments, data, "name", "id")
          } else {
            setDepartments([]);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        hideBackdrop();
      });
  };

  // Formik form validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (DialogData && DialogData.name) || "",
      branchId: (DialogData && DialogData.branchId) || "",
      departmentId: (DialogData && DialogData.departmentId) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .trim()
        .matches(
          FORM_VALIDATIONS.TEXT_INPUT.REGEX.INITIAL,
          FORM_VALIDATIONS.TEXT_INPUT.MESAAGE.INITIAL
        )
        .required(USE_FORMIK_SCHEMA.AREA_MASTER.AREA_NAME),
      branchId: Yup.string().required(USE_FORMIK_SCHEMA.AREA_MASTER.BRANCH),
      departmentId: Yup.string().required(USE_FORMIK_SCHEMA.AREA_MASTER.DEPT),
    }),
    onSubmit: (values) => {
      const payload = {
        ...values,
        updatedBy: authUser.uid,
      };
      if (isUpdateMode) {
        const update_payload = {
          ...payload,
          accountId: accountId,
          areaId: DialogData?.id,
        };
        // console.log("update_payload: ", update_payload);
        updateExistingArea(update_payload);
      } else {
        if (checkDuplicateEntity(AllAreaNames, values.name)) {
          showSnackbar(
            APP_MESSAGE.AREA_MASTER.DUPLICATE_LOCATION_NAME,
            SNACKBAR_VARIANT.ERROR
          );
        } else {
          const create_upload = {
            ...payload,
            createdBy: authUser?.uid,
            name: replaceTextToCaplitalize(payload.name.trim()),
            accountId: accountId,
          };
          // console.log("create_payload: ", create_upload);
          createNewArea(create_upload);
        }
      }
    },
  });

  // Function used reset dialog box
  function handleResetDialogBox() {
    ToggleDialogBox("Create/Update");
    validation.handleReset();
    SetDialogData(null);
    setDepartments([]);
  }

  useEffect(() => {
    if (navigator.onLine) {
      if (DialogData) {
        const { branchId } = DialogData;
        fetchAllDepartmentsOfBranch(branchId);
      }
    } else {
      showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [DialogData]);

  // Function used handle change in location in-charge
  const handleDepartmentIncharge = (event, value) => {
    const inchargeList = value
      .map((item) => ({
        departmentInchargeName: item.label,
        departmentInchargeId: item.value,
      }))
      .filter(
        (user, index, self) =>
          index ===
          self.findIndex(
            (u) => u.departmentInchargeId === user.departmentInchargeId
          )
      );
    validation.setFieldValue("departmentInchargeList", inchargeList);
  };

  return (
    <Dialog
      open={Open}
      disableEscapeKeyDown={true}
      maxWidth="md"
      disableEnforceFocus={true}
      fullWidth
      slotProps={{
        style: {
          opacity: 0.7,
        },
      }}
    >
      <DialogTitle id="responsive-dialog-title">
        <Typography
          className="inter-medium-500"
          style={{
            fontSize: "18px",
          }}
        >
          {Title}
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleResetDialogBox}
        style={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Icons.Close />
      </IconButton>
      <DialogContent dividers>
        <div>
          <Grid2 container spacing={2} className="mb-1">
            <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Area Name
              </Typography>
              <AppInputField
                Name={"name"}
                Id={"name"}
                Type={"text"}
                Disabled={isCreateOrUpdateClicked}
                Value={validation.values.name || ""}
                OnBlur={validation.handleBlur}
                OnChange={validation.handleChange}
                IsCapitalizeRequired={true}
                // Label={"Location Name *"}
                PlaceHolder={"Enter area name"}
                Error={
                  validation.touched.name && validation.errors.name
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.name && validation.errors.name ? (
                    <MUIErrorText ErrorMessage={validation.errors.name} />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select Branch
              </Typography>
              {/* <AppInputField
                Name={"branchId"}
                Id={"branchId"}
                IsSelect={true}
                SelectOptions={ListOfAllBranches || []}
                Disabled={isCreateOrUpdateClicked || isUpdateMode}
                Value={validation.values.branchId || ""}
                OnBlur={validation.handleBlur}
                OnChange={(event) => {
                  if (navigator.onLine) {
                    validation.handleChange(event);
                    const { value } = event.target;
                    fetchAllDepartmentsOfBranch(value);
                    validation.setFieldValue("departmentId", "");
                    validation.setFieldTouched(
                      "departmentId",
                      false,
                      false
                    );
                  } else {
                    showSnackbar(
                      ERROR_MESSAGE.INTERNET_ERROR,
                      SNACKBAR_VARIANT.ERROR
                    );
                  }
                }}
                PlaceHolder={"Select branch"}
                Error={
                  validation.touched.branchId && validation.errors.branchId
                    ? true
                    : false
                }
                HelperText={validation.errors.branchId}
              /> */}
              <AppAutoCompleteField
                IsMultiple={false}
                TextInputName={"branchId"}
                TextInputId={"branchId"}
                Id={"branchId"}
                TextInputPlaceholder={"Select branch"}
                Options={
                  ListOfAllBranches?.filter((br) => br.value !== "All") || []
                }
                Disabled={isCreateOrUpdateClicked || isUpdateMode}
                Value={validation.values.branchId || ""}
                HandleOnBlur={validation.handleBlur}
                HandleOnChange={(event, value) => {
                  const event_ = {
                    ...event,
                    target: {
                      ...event?.target,
                      value: value?.value || "",
                      name: "branchId",
                      id: "branchId",
                    },
                  };
                  validation.handleChange(event_);
                  if (value?.value) {
                    fetchAllDepartmentsOfBranch(value?.value);
                    validation.setFieldValue("departmentId", "");
                    validation.setFieldTouched("departmentId", false, false);
                  }
                }}
                TextInputError={
                  validation.touched.branchId && validation.errors.branchId
                    ? true
                    : false
                }
                TextInputHelperText={
                  validation.touched.branchId && validation.errors.branchId
                    ? validation.errors.branchId
                    : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select Department
              </Typography>
              {/* <AppInputField
                Name={"departmentId"}
                Id={"departmentId"}
                IsSelect={true}
                SelectOptions={departments || []}
                Disabled={isCreateOrUpdateClicked || isUpdateMode}
                Value={validation.values.departmentId || ""}
                OnBlur={validation.handleBlur}
                OnChange={validation.handleChange}
                PlaceHolder={"Select department"}
                Error={
                  validation.touched.departmentId &&
                  validation.errors.departmentId
                    ? true
                    : false
                }
                HelperText={validation.errors.departmentId}
              /> */}
              <AppAutoCompleteField
                IsMultiple={false}
                TextInputName={"departmentId"}
                TextInputId={"departmentId"}
                Id={"departmentId"}
                TextInputPlaceholder={"Select department"}
                Options={departments || []}
                Disabled={isCreateOrUpdateClicked || isUpdateMode}
                Value={validation.values.departmentId || ""}
                HandleOnBlur={validation.handleBlur}
                HandleOnChange={(event, value) => {
                  const event_ = {
                    ...event,
                    target: {
                      ...event?.target,
                      value: value?.value || "",
                      name: "departmentId",
                      id: "departmentId",
                    },
                  };
                  validation.handleChange(event_);
                }}
                TextInputError={
                  validation.touched.departmentId &&
                  validation.errors.departmentId
                    ? true
                    : false
                }
                TextInputHelperText={
                  validation.touched.departmentId && validation.errors.departmentId
                    ? validation.errors.departmentId
                    : null
                }
              />
            </Grid2>
          </Grid2>
          <Grid2 container spacing={2} className="mt-3">
            {!isUpdateMode ? (
              <Grid2 size={{ xs: 6 }}>
                <AppButton
                  Type={"reset"}
                  IsDisabled={isCreateOrUpdateClicked}
                  OnPress={validation.handleReset}
                  children={"Reset"}
                  Color={"error"}
                />
              </Grid2>
            ) : null}
            <Grid2 size={{ xs: isUpdateMode ? 12 : 6 }}>
              <AppButton
                Type={"submit"}
                OnPress={() => {
                  if (navigator.onLine) {
                    validation.handleSubmit();
                  } else {
                    showSnackbar(
                      ERROR_MESSAGE.INTERNET_ERROR,
                      SNACKBAR_VARIANT.ERROR
                    );
                  }
                }}
                IsDisabled={isCreateOrUpdateClicked}
                LoadingState={isCreateOrUpdateClicked}
              >
                {DialogData !== null ? "Update" : "Create"}
              </AppButton>
            </Grid2>
          </Grid2>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CreateNewOrUpdateAreaModal;
